import { z } from 'zod/v4';
export const GetTableViewSchemaInputSchema = z.object({
    tableViewId: z.string(),
});
export const GetTableViewSchemaOutputSchema = z.object({
    columns: z.array(z.object({
        id: z.string(),
        name: z.string(),
        type: z.enum([
            'text',
            'date',
            'number',
            'verbatim',
            'options',
            'unknown',
        ]),
        options: z
            .array(z.object({ id: z.string(), value: z.string() }))
            .nullish(),
    })),
});
//# sourceMappingURL=get-table-view-schema.js.map